import { render, staticRenderFns } from "./Qualitys.vue?vue&type=template&id=88797626&scoped=true&"
import script from "./Qualitys.vue?vue&type=script&lang=js&"
export * from "./Qualitys.vue?vue&type=script&lang=js&"
import style0 from "./Qualitys.vue?vue&type=style&index=0&id=88797626&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88797626",
  null
  
)

export default component.exports